module.exports = __webpack_public_path__ + "static/media/undraw_page_not_found_re_e9o6.54d170c6.svg";